import React, { FC, useState, useEffect } from "react";
import { renderFeeRiskProfileDiagram } from "@aderant/vpd-illustration";

type FeeRiskProfileDiagramProps = {
  totalWidth?: number;
  currencySymbol: string;
  lowestAnticipatedFee?: number;
  highestAnticipatedFee?: number;
  lowestFee?: number;
  highestFee?: number;
  fixedFee?: number;
  cappedFee?: number;
};

export const FeeRiskProfileDiagram: FC<FeeRiskProfileDiagramProps> = ({
  totalWidth = 800,
  currencySymbol,
  lowestAnticipatedFee,
  highestAnticipatedFee,
  lowestFee,
  highestFee,
  fixedFee,
  cappedFee,
}) => {
  const [svgString, setSvgString] = useState<string | null>(null);

  useEffect(() => {
    const fetchSvgString = async () => {
      const result = (await renderFeeRiskProfileDiagram({
        totalWidth,
        currencySymbol,
        lowestAnticipatedFee,
        highestAnticipatedFee,
        lowestFee,
        highestFee,
        fixedFee,
        cappedFee,
      })) as string;
      setSvgString(result);
    };

    fetchSvgString();
  }, [
    totalWidth,
    currencySymbol,
    lowestAnticipatedFee,
    highestAnticipatedFee,
    lowestFee,
    highestFee,
    fixedFee,
    cappedFee,
  ]);

  if (!svgString) {
    return null;
  }

  return <div dangerouslySetInnerHTML={{ __html: svgString }} />;
};
